export type Anzeige =
  | 'ABSATZ_PRODUKTIVITAET'
  | 'OEFFNUNGSZEITEN'
  | 'PERSONALEINSATZ'
  | 'PERSONALKOSTEN'
  | 'UMSATZ_PRODUKTIVITAET'
  | 'UMSATZ_ABSATZ_PRODUKTIVITAET';

export const TagebuchAnzeige: Record<string, Anzeige> = {
  Absatzproduktivitaet: 'ABSATZ_PRODUKTIVITAET',
  Oeffnungszeiten: 'OEFFNUNGSZEITEN',
  Personaleinsatz: 'PERSONALEINSATZ',
  Personalkosten: 'PERSONALKOSTEN',
  Produktivitaet: 'UMSATZ_PRODUKTIVITAET',
  DoesNotExist: 'UMSATZ_ABSATZ_PRODUKTIVITAET',
};
export type TagebuchAnzeige = typeof TagebuchAnzeige;
